import { gql } from 'graphql-request';

export const REFRESH_AUTH_TOKEN_QUERY = gql`
  query ($refreshToken: String!) {
    refreshAuthToken(refreshToken: $refreshToken) {
      __typename
      tokenType
      expiresIn
      authToken
      refreshToken
      secureToken
      shouldRegister
      code
      message
    }
  }
`;
